import React, { CSSProperties, FC } from "react";
import style from "./style.module.scss";
import validationError from "../../assets/images/validationError.svg";

interface ITextArea {
  id?: string;
  label?: string;
  placeholder?: string;
  onChange: (v: string) => void;
  onBlur?: (e: React.FocusEvent<any>) => void;
  error?: string;
  isTouched?: boolean;
  value: string;
  customStyle?: CSSProperties;
  textareaHeight?: string;
  maxLength?: number;
  autoComplete?: string | undefined;
  isDisabled?: boolean;
}
export const TextAreaV2: FC<ITextArea> = ({
  label,
  placeholder,
  error = "",
  id,
  isTouched = false,
  onBlur,
  onChange,
  value,
  customStyle = {},
  textareaHeight,
  maxLength,
  autoComplete = "off",
  isDisabled = false,
}) => {
  return (
    <div
      className={`${style.wrapper} ${
        isTouched && error ? style.input_wrapperWithWarning : ""
      }`}
      style={{
        ...customStyle,
        opacity: isDisabled ? 0.5 : 1,
      }}
    >
      {label ? (
        <label
          className={`${style.labelText} ${
            isTouched && error ? style.labelWithWarning : ""
          }`}
          htmlFor={id}
        >
          {label}
        </label>
      ) : null}
      <textarea
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          onChange(e.currentTarget.value);
        }}
        name={id}
        className={`${style.textArea} ${
          isTouched && error ? style.customInputWithWarning : ""
        }`}
        aria-describedby={`${id ?? ""}-error`}
        aria-invalid={isTouched && error && !value ? true : undefined}
        style={{
          height: textareaHeight ? textareaHeight : "",
        }}
        maxLength={maxLength}
        autoComplete={autoComplete}
        disabled={isDisabled}
      />
      <div
        className={`${style.errorMessage} ${
          isTouched && error ? "" : style.disabledError
        }`}
        id={`${id ?? ""}-error`}
        role={isTouched && error ? "alert" : undefined}
      >
        {error}
      </div>
      <img
        src={validationError}
        alt="err"
        className={`${style.warningImg} ${
          isTouched && error ? "" : style.disabledError
        }`}
      />
    </div>
  );
};
